import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/spinner.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Current MFA factors:")
], -1)
const _hoisted_4 = { id: "spinner" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Failed to reset MFA."))
      : _createCommentVNode("", true),
    (_ctx.mfaInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFactorSummary, (factor) => {
            return (_openBlock(), _createElementBlock("div", { key: factor }, _toDisplayString(factor), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        href: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.resetFactors()), ["prevent"]))
      }, " Reset MFA "),
      _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
        [_vShow, _ctx.isProcessing]
      ])
    ])
  ], 64))
}